import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';
export const payrollAgreementFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Buscar convênios` },
  { key: 'name', type: 'text', label: msg`Nome do convênio` },
  {
    key: 'initialDate',
    to: 'finalDate',
    type: 'dateRange',
    label: msg`Data`,
    fromLabel: msg`Filtrar por data inicial`,
    toLabel: msg`Filtrar por data final`,
  },
]);
